export const editUserSettingsRoutesName = {
    editUserSettings: "edit-user-settings",
};
